import type { ReactNode } from 'react'
import { useViewportStore } from '@/stores'

interface CanvasBoardProps {
  children?: ReactNode
}

/**
 * The inner board that receives the CSS transform (scale + translate).
 * Equivalent to #board in the legacy HTML.
 *
 * Transform: scale(sc) translate(tx, ty) with transformOrigin: 0 0
 *   → a canvas point (cx, cy) maps to screen (sc*(cx+tx), sc*(cy+ty))
 *
 * Children (tables, SVG layers) are absolutely positioned in canvas space
 * and do not need to know about zoom/pan.
 */
export function CanvasBoard({ children }: CanvasBoardProps) {
  const sc = useViewportStore((s) => s.sc)
  const tx = useViewportStore((s) => s.tx)
  const ty = useViewportStore((s) => s.ty)

  return (
    <div
      id="board"
      style={{
        transform: `scale(${sc}) translate(${tx}px, ${ty}px)`,
        transformOrigin: '0 0',
        position: 'absolute',
        inset: 0,
        zIndex: 1,
      }}
    >
      {children}
    </div>
  )
}
